export default function createLSM() {
  const api = {};
  const lsKey = "ked.pistacja";
  const storage = window.localStorage.getItem(lsKey)
    ? JSON.parse(localStorage.getItem(lsKey))
    : {};

  api.get = (key) => (storage[key] !== undefined ? storage[key] : undefined);

  api.set = (key, value) => {
    storage[key] = value;
    saveToLocalStorage();
    return value;
  };

  api.remove = (...keys) => {
    keys.forEach((key) => {
      if (typeof key === "string" && storage.hasOwnProperty(key)) {
        delete storage[key];
      }
    });
    saveToLocalStorage();
  };

  api.clear = () => {
    Object.keys(storage).forEach((key) => delete storage[key]);
    saveToLocalStorage();
  };

  // ---- Helpers ----------------

  function saveToLocalStorage() {
    window.localStorage.setItem(lsKey, JSON.stringify(storage));
  }

  return api;
}
